import { CategoryAgent } from '../models/category';
import apiClient from './apiClient';
import { NetworkError, UnauthorizedError, ForbiddenError, NotFoundError, ApiError } from './errors';

export const fetchTrainingCategories = async (boxId: number): Promise<CategoryAgent[]> => {
  try {
    const { data } = await apiClient.get<{
      success: boolean;
      status: number;
      data: CategoryAgent[];
    }>(`/trainings/categories/${boxId}`);
    return data.data;
  } catch (err: any) {
    if (err.isAxiosError) {
      if (!err.response) throw new NetworkError(err.message);
      switch (err.response.status) {
        case 401:
          throw new UnauthorizedError();
        case 403:
          throw new ForbiddenError();
        case 404:
          throw new NotFoundError();
        default:
          throw new ApiError(err.response.status, err.message);
      }
    }
    throw err;
  }
};
